import { routerMiddleware } from 'connected-react-router'
import { createStore as _createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunkMiddleware from 'redux-thunk'

import createReducer from './reducers'

const composeEnhancers = composeWithDevTools({
  // Specify name here, actionsBlacklist, actionsCreators and other options if needed
})

function createStore(coreReducers = {}, history) {
  return _createStore(
    createReducer(history, coreReducers),
    composeEnhancers(applyMiddleware(routerMiddleware(history), thunkMiddleware)),
  )
}

export { createStore }
